<script>
import { authMethods, authFackMethods, notificationMethods } from "@/state/helpers";
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";
import { mapState } from "vuex";
// import { alpha } from "@/helpers/helper";
// import { required } from "vuelidate/lib/validators";

//import vue2Dropzone from 'vue2-dropzone'
//import 'vue2-dropzone/dist/vue2Dropzone.min.css'
/**
 * Register component
 */
export default {
  page: {
    title: "Register",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    //vueDropzone: vue2Dropzone,
    Layout,
  },
  data() {
    return {
      company: {
        otp1: "",
        otp2: "",
        otp3: "",
        otp4: "",
        otp5: "",
        otp6: "",
        email: "",
      },

      otp: [
        { length: 1, value: "", placeholder: "8" },
        { length: 1, value: "", placeholder: "1" },
        { length: 1, value: "", placeholder: "8" },
        { length: 1, value: "", placeholder: "2" },
        { length: 1, value: "", placeholder: "5" },
        { length: 1, value: "", placeholder: "5" },
      ],
      logo: process.env.VUE_APP_MIX_BASE_URL + "images/stakeholder_logo.png",
      submitted: false,
      regError: null,
      tryingToRegister: false,
      isRegisterError: false,
      registerSuccess: false,
      greet: "",
      color: {
        "text-danger": true,
      },
    };
  },
  // validations: {
  //   user: {
  //     otp1: {
  //       required,
  //       alpha,
  //     },
  //   },
  // },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  mounted() {
    this.getGreetingMsg();
    let user = JSON.parse(localStorage.getItem("user"));

    this.company.email = user.email;

    let sessionId = this.$route.query.session_id;

    if (sessionId !== undefined) {
      let details = [this.$route.query, this.company.email];

      this.storeStripeData(details);
    } else {
      console.log("null");
    }
    // let planId = this.$route.query.plan_id;
    // let emailId = user.email;
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to register the user in with the email, username
    // and password they provided.
    getGreetingMsg() {
      var hrs = new Date().getHours();

      if (hrs < 12) this.greet = this.$t("login.morning");
      else if (hrs >= 12 && hrs <= 18) this.greet = this.$t("login.afterNoon");
      else if (hrs >= 18 && hrs <= 24) this.greet = this.$t("login.evening");
      return this.greet;
    },
    tryToOTP() {
      this.submitted = true;
      // stop here if form is invalid
      let user = JSON.parse(localStorage.getItem("user"));
      var data = { ...this.otp, email: user.email };

      this.companyotpverify(data).then((res) => {
        if (res) {
          console.log("otp", res);
          // return "/login";
          //route.push("/login");
          this.$router.push({ name: "login" });
        } else {
          return;
        }
      });
    },
    nextField(current) {
      var i;
      for (i = 0; i < current.form.elements.length; i++) {
        if (current.form.elements[i].tabIndex - current.tabIndex == 1) {
          current.form.elements[i].focus();
          if (current.form.elements[i].type == "text") {
            current.form.elements[i].select();
          }
        }
      }
    },

    nameKeydown(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
    // isNumber: function (evt) {
    //   evt = evt ? evt : window.event;
    //   var charCode = evt.which ? evt.which : evt.keyCode;
    //   if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
    //     evt.preventDefault();
    //   } else {
    //     return true;
    //   }
    // },
    isNumber(event) {
      if (!/[0-9\s]/.test(event.key)) {
        this.ignoredValue = event.key ? event.key : "";
        event.preventDefault();
      }
    },

    next(e) {
      e.target?.nextSibling?.focus();
    },

    deleteCode(e) {
      let index = parseInt(e.target.dataset.index);

      if (e.keyCode == 8 && index != 0) {
        //e.target.disabled = false

        var newValue = this.$refs[`input-${parseInt(index - 1)}`][0].value;

        this.otp[index].value = "";
        //  this.$refs[`input-${parseInt(index-1)}`][0].disabled = false
        this.$refs[`input-${parseInt(index - 1)}`][0].focus();
        this.$refs[`input-${parseInt(index - 1)}`][0].value = newValue;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="text-center mb-5 text-muted">
          <a class="d-block auth-logo">
            <img
              :src="logo"
              alt=""
              height="50"
              width="200"
              class="auth-logo-dark mx-auto"
            />
          </a>
          <p class="mt-3">Stakeholder Club Company Admin</p>
        </div>
      </div>
    </div>
    <div class="justify-content-center row">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body">
            <div class="p-2">
              <div class="text-center">
                <div class="avatar-md mx-auto">
                  <div class="avatar-title rounded-circle bg-light">
                    <i class="bx bxs-envelope h1 mb-0 text-primary"></i>
                  </div>
                </div>
                <div class="p-2 mt-4">
                  <h4>Verify your email</h4>
                  <p class="mb-5">
                    Please enter the 6 digit code sent to
                    <span class="font-weight-semibold">{{ company.email }}</span>
                  </p>
                  <form class="" @submit.prevent="tryToOTP">
                    <div class="row">
                      <div class="col-12">
                        <div class="verification mb-3">
                          <label for="digit1-input" class="sr-only">Dight 1</label>
                          <div>
                            <input
                              type="text"
                              maxlength="1"
                              v-model="key.value"
                              v-for="(key, i) in otp"
                              :data-index="i"
                              :key="i"
                              :ref="`input-${i}`"
                              :data-length="key.length"
                              style="
                                width: 45px;
                                height: 42px;
                                padding: 6px;
                                border-radius: 8px;
                                font-size: 16px;
                                text-align: center;
                                margin-right: 15px;
                                border: 1px solid rgb(206, 212, 218);
                                text-transform: uppercase;
                              "
                              @input="next($event)"
                              @keypress="isNumber($event)"
                              @keydown="deleteCode($event)"
                            />
                          </div>
                        </div>

                        <!-- <div class="verification mb-3">
                          <label for="digit1-input" class="sr-only">Dight 1</label>
                          <div>
                            <input
                              type="text"
                              maxlength="1"
                              style="
                                width: 45px;
                                height: 42px;
                                padding: 6px;
                                border-radius: 8px;
                                font-size: 16px;
                                text-align: center;
                                margin-right: 15px;
                                border: 1px solid rgb(206, 212, 218);
                                text-transform: uppercase;
                              "
                              v-model="company.otp1"
                              @input="next"
                              @keypress="isNumber($event)"
                              @keydown="deleteCode($event)"
                            />
                            <input
                              type="text"
                              maxlength="1"
                              style="
                                width: 45px;
                                height: 42px;
                                padding: 6px;
                                border-radius: 8px;
                                font-size: 16px;
                                text-align: center;
                                margin-right: 15px;
                                border: 1px solid rgb(206, 212, 218);
                                text-transform: uppercase;
                              "
                              v-model="company.otp2"
                              @input="next"
                              @keypress="isNumber($event)"
                              @keydown="deleteCode($event)"
                            />
                            <input
                              type="text"
                              maxlength="1"
                              style="
                                width: 45px;
                                height: 42px;
                                padding: 6px;
                                border-radius: 8px;
                                font-size: 16px;
                                text-align: center;
                                margin-right: 15px;
                                border: 1px solid rgb(206, 212, 218);
                                text-transform: uppercase;
                              "
                              v-model="company.otp3"
                              @input="next"
                              @keypress="isNumber($event)"
                            />
                            <input
                              type="text"
                              maxlength="1"
                              style="
                                width: 45px;
                                height: 42px;
                                padding: 6px;
                                border-radius: 8px;
                                font-size: 16px;
                                text-align: center;
                                margin-right: 15px;
                                border: 1px solid rgb(206, 212, 218);
                                text-transform: uppercase;
                              "
                              v-model="company.otp4"
                              @input="next"
                              @keypress="isNumber($event)"
                            />
                            <input
                              type="text"
                              maxlength="1"
                              style="
                                width: 45px;
                                height: 42px;
                                padding: 6px;
                                border-radius: 8px;
                                font-size: 16px;
                                text-align: center;
                                margin-right: 15px;
                                border: 1px solid rgb(206, 212, 218);
                                text-transform: uppercase;
                              "
                              v-model="company.otp5"
                              @input="next"
                              @keypress="isNumber($event)"
                            />
                            <input
                              type="text"
                              maxlength="1"
                              style="
                                width: 45px;
                                height: 42px;
                                padding: 6px;
                                border-radius: 8px;
                                font-size: 16px;
                                text-align: center;
                                margin-right: 15px;
                                border: 1px solid rgb(206, 212, 218);
                                text-transform: uppercase;
                              "
                              v-model="company.otp6"
                              @keypress="isNumber($event)"
                            />
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <div class="mt-4">
                      <b-button
                        type="submit"
                        variant="primary"
                        class="btn btn-success w-md bg-login-black"
                      >
                        Confirm
                      </b-button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-5 text-center">
          <p>
            {{ $t("register.alreadyAccountExisting") }}
            <router-link tag="a" to="/login" class="font-weight-medium button-forgot">{{
              $t("register.login")
            }}</router-link>
          </p>
          <p>
            © {{ new Date().getFullYear() }} {{ $t("title.footerText") }}
            <!-- <i
              class="mdi mdi-heart text-danger"
            ></i> by Themesbrand -->
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.button-forgot {
  color: #d6542d;
}
.button-forgot:hover {
  color: #d6542d !important;
}
.bg-login-black {
  background-color: #1c1c1e !important;
  border-color: #1c1c1e !important;
}
</style>
